export default __webpack_public_path__ + "static/media/DAIF_Data_Screen1_in.6e9ad109.mp4";